const isThirdPartySource = (sourceCode) =>
  String(sourceCode || "")
    .toUpperCase()
    .includes("3RD");

export function getMediaTypeGroup(item = {}) {
  const hasThirdPartyFlag = typeof item.isThirdParty === "boolean";
  const hasSourceCode = Boolean(String(item.sourceCode || "").trim());

  if (hasThirdPartyFlag && hasSourceCode) {
    return item.isThirdParty && isThirdPartySource(item.sourceCode)
      ? "3rd"
      : "wwg";
  }

  if (hasThirdPartyFlag) {
    return item.isThirdParty ? "3rd" : "wwg";
  }

  if (hasSourceCode) {
    return isThirdPartySource(item.sourceCode) ? "3rd" : "wwg";
  }

  return item.typeGroup;
}
